import styled from "styled-components";

export const Container = styled.div(({ theme }) => {
    return {
        height: theme.spacing.medium,
        backgroundColor: "transparent",
    };
});
